"use client"

import { useEffect } from "react"
import { trackEvent } from "../lib/analytics"

const thresholds = [25, 50, 75, 100]

const ScrollDepthTracker = () => {
  useEffect(() => {
    const tracked = new Set()

    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight
      if (scrollHeight <= 0) return
      const percent = Math.round((window.scrollY / scrollHeight) * 100)

      for (const t of thresholds) {
        if (percent >= t && !tracked.has(t)) {
          tracked.add(t)
          trackEvent("scroll_depth", { percent: t })
        }
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return null
}

export default ScrollDepthTracker
